// extracted by mini-css-extract-plugin
export default {"root":"RoleContactCard-root_DSePu"};